import React from 'react';
import { Switch } from 'react-router-dom';

import ErrorBoundaryRoute from 'app/shared/error/error-boundary-route';

import RepresentativeTruckImplement from './representative-truck-implement';
import RepresentativeTruckImplementDetail from './representative-truck-implement-detail';
import RepresentativeTruckImplementUpdate from './representative-truck-implement-update';
import RepresentativeTruckImplementDeleteDialog from './representative-truck-implement-delete-dialog';

const Routes = ({ match }) => (
  <>
    <Switch>
      <ErrorBoundaryRoute exact path={`${match.url}/new`} component={RepresentativeTruckImplementUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id/edit`} component={RepresentativeTruckImplementUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id`} component={RepresentativeTruckImplementDetail} />
      <ErrorBoundaryRoute path={match.url} component={RepresentativeTruckImplement} />
    </Switch>
    <ErrorBoundaryRoute exact path={`${match.url}/:id/delete`} component={RepresentativeTruckImplementDeleteDialog} />
  </>
);

export default Routes;
